// Componentes utilitários para estados de carregamento
// Usa as classes .skeleton* definidas em App.css

export function SkeletonLine({ width, height = 14, style, ...rest }) {
  return (
    <span
      className="skeleton"
      style={{ display: 'block', height, width: width || '100%', ...style }}
      {...rest}
    />
  );
}

export function SkeletonCircle({ size = 36, style, ...rest }) {
  return (
    <span
      className="skeleton skeleton-circle"
      style={{ display: 'block', width: size, height: size, ...style }}
      {...rest}
    />
  );
}

export function SkeletonSquare({ size = 40, style, ...rest }) {
  return (
    <span
      className="skeleton skeleton-square"
      style={{ display: 'block', width: size, height: size, ...style }}
      {...rest}
    />
  );
}

export function SkeletonStat() {
  return (
    <div className="stat-skeleton">
      <SkeletonSquare size={42} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flex: 1 }}>
        <SkeletonLine width="60%" height={22} />
        <SkeletonLine width="40%" height={11} />
      </div>
    </div>
  );
}

export function SkeletonTableRows({ rows = 5, cols = 5 }) {
  return Array.from({ length: rows }).map((_, i) => (
    <tr key={i} className="is-skeleton">
      {Array.from({ length: cols }).map((__, j) => (
        <td key={j}>
          <SkeletonLine width={j === 0 ? '70%' : `${50 + ((i + j) % 3) * 15}%`} height={13} />
        </td>
      ))}
    </tr>
  ));
}

export function SkeletonCard({ height = 180 }) {
  return (
    <div className="card">
      <SkeletonLine width="40%" height={16} style={{ marginBottom: 16 }} />
      <SkeletonLine width="100%" height={height - 50} style={{ borderRadius: 'var(--radius)' }} />
    </div>
  );
}
